<h2 mat-dialog-title>Draft invoice via prompt</h2>

<mat-dialog-content>
  <p class="helper">Describe what the invoice should cover. This will land in the first line item description.</p>
  <mat-form-field appearance="outline" class="full">
    <mat-label>Prompt</mat-label>
    <textarea matInput [(ngModel)]="promptText" rows="5" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="12"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" (click)="submit()" [disabled]="!promptText?.trim()">Create invoice</button>
</mat-dialog-actions>
